package com.steamstreet.vegasful.browser

/**
 * Inline-SVG icons rendered on the client. This mirrors the server-side
 * registry in `server-pages` and replaces the FontAwesome CDN kit: the icons
 * the browser code injects are self-contained markup, so they need no external
 * font or stylesheet.
 *
 * Each icon is sized to `1em` and painted with `currentColor`, so surrounding
 * `font-size` and `color` rules continue to control it exactly as the
 * FontAwesome glyphs did. Only the handful of icons the client renders directly
 * live here; everything else is server-rendered.
 */
private const val strokeSvgAttrs =
    """fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round""""

private val clientIcons: Map<String, String> = mapOf(
    // Solid heart so the "liked" state simply recolors it.
    "heart" to """<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true" focusable="false" style="display:inline-block;vertical-align:-0.125em"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>""",
    "share" to """<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" $strokeSvgAttrs width="1em" height="1em" aria-hidden="true" focusable="false" style="display:inline-block;vertical-align:-0.125em"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"/><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"/></svg>"""
)

/** Raw inline-SVG markup for [id], or an empty string for an unknown id. */
fun clientIconSvg(id: String): String = clientIcons[id] ?: ""

/**
 * A self-spinning loader, animated with SMIL so it needs no companion CSS
 * keyframes. Replaces the previous `fa-cog fa-spin` spinner.
 */
fun spinnerSvg(): String =
    """<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" $strokeSvgAttrs width="1em" height="1em" aria-hidden="true" focusable="false" style="display:inline-block;vertical-align:-0.125em">""" +
            """<path d="M21 12a9 9 0 1 1-6.219-8.56">""" +
            """<animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="0.8s" repeatCount="indefinite"/>""" +
            """</path></svg>"""
